module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0603-82400ed5f830d7f86bc152d2dbeadd30.jpg";